import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const getTranscriptStudentFeedQuery = gql`
  query getTranscriptStudentFeed(
    $first: Int!
    $organizationId: ID!
    $after: String
    $filters: OrgConnectionFilterInput
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $userArchivedFilters: UserArchivedFilters
    $studentCurriculumProgramFilter: StudentCurriculumProgramFilter
    $userYearGroupMapFilters: YearGroupFilters
    $yearGroupGradeFilters: YearGroupGradeFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        students(
          first: $first
          after: $after
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          totalCount
          edges {
            node {
              id
              profileImage
              ...userNameFields
              sourceId
              isArchivedV2(filters: $userArchivedFilters)
              curriculumPrograms(filters: $studentCurriculumProgramFilter) {
                id
                label
                acronym
              }
              yearGroup(filters: $userYearGroupMapFilters) {
                id
                name
                grade(filters: $yearGroupGradeFilters) {
                  id
                  name
                  globalGrade {
                    id
                    name
                  }
                }
              }
              transcriptSummary {
                id
                grades {
                  id
                  grade {
                    id
                    name
                  }
                }
                lastUpdatedAt
                lastUpdatedBy {
                  id
                  ...userNameFields
                  profileImage
                }
                lastTranscriptGeneratedAt
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
  ${userNameFragment}
`;

export const getTranscriptStudentIdsQuery = gql`
  query getTranscriptStudentIds(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        students(filters: $filters) {
          totalCount
          edges {
            node {
              id
              yearGroup {
                id
                curriculumProgram {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getTranscriptStudentFilterOptionsQuery = gql`
  query getTranscriptStudentFilterOptions(
    $organizationId: ID!
    $filters: YearGroupsFilters
    $curriculumIds: [ID]
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        curriculumPrograms(curriculumIds: $curriculumIds) {
          id
          label
          logo
          yearGroups(filters: $filters) {
            id
            name
            grade {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const getSchoolYearGroupsQuery = gql`
  query getSchoolYearGroups($schoolId: ID!, $filters: YearGroupsFilters) {
    node(id: $schoolId, type: CURRICULUM_PROGRAM) {
      id
      ... on CurriculumProgram {
        yearGroups(filters: $filters) {
          id
          name
          grade {
            id
            name
          }
          students {
            allCount
          }
        }
      }
    }
  }
`;

export const getSchoolsWithYearGroupsQuery = gql`
  query getSchoolsWithYearGroups(
    $organizationId: ID!
    $filters: YearGroupsFilters
    $curriculumIds: [ID]
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        curriculumPrograms(curriculumIds: $curriculumIds) {
          id
          label
          logo
          yearGroups(filters: $filters) {
            id
            name
            grade {
              id
              name
            }
            students {
              allCount
            }
          }
        }
      }
    }
  }
`;

export const getYearGroupStudentsQuery = gql`
  query getYearGroupStudents(
    $yearGroupId: ID!
    $studentFilters: GroupStudentFilter
  ) {
    node(id: $yearGroupId, type: YEAR_GROUP) {
      id
      ... on YearGroup {
        students(filters: $studentFilters) {
          edges {
            node {
              id
              ...userNameFields
              profileImage
            }
          }
        }
      }
    }
  }
  ${userNameFragment}
`;

export const getTranscriptEntityStudentsQuery = gql`
  query getTranscriptEntityStudents($id: ID!, $type: ENTITY_TYPE_ENUM!) {
    node(id: $id, type: $type) {
      id
      ... on TranscriptGrade {
        associations {
          edges {
            entity {
              ... on Student {
                id
                ...userNameFields
                profileImage
              }
            }
          }
        }
      }
      ... on TranscriptSchool {
        associations {
          edges {
            entity {
              ... on Student {
                id
                ...userNameFields
                profileImage
              }
            }
          }
        }
      }
      ... on TranscriptAcademicYear {
        associations {
          edges {
            entity {
              ... on Student {
                id
                ...userNameFields
                profileImage
              }
            }
          }
        }
      }
      ... on TranscriptGradingPeriod {
        associations {
          edges {
            entity {
              ... on Student {
                id
                ...userNameFields
                profileImage
              }
            }
          }
        }
      }
      ... on TranscriptCourse {
        associations {
          edges {
            entity {
              ... on Student {
                id
                ...userNameFields
                profileImage
              }
            }
          }
        }
      }
      ... on TranscriptLevel {
        associations {
          edges {
            entity {
              ... on Student {
                id
                ...userNameFields
                profileImage
              }
            }
          }
        }
      }
      ... on TranscriptGradeScale {
        associations {
          edges {
            entity {
              ... on Student {
                id
                ...userNameFields
                profileImage
              }
            }
          }
        }
      }
    }
  }
  ${userNameFragment}
`;
